<div class="dialog-wrapper">
    <div class="dialog-top">
        <div class="dialog-top-left">
            <span class="span-heading">{{'machine_view.loss_popup.heading' | translate}}</span>

            <div class="dialog-sub-title">
                <span *ngIf="data?.shiftOrThirty === '30 Minutes'">
                    (30 {{'machine_view.minutes' | translate}})
                </span>
                <span *ngIf="data?.shiftOrThirty === 'Shift'">
                    ({{'common.shift' | translate}} {{data?.shiftIndex}})
                </span>
            </div>
        </div>
        <div class="dialog-top-right">
            <mat-dialog-actions class="dialog-close">
                <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
                    (click)="dialogClose()"  (keydown.enter)="dialogClose()"
                    (keydown.space)="dialogClose()">
            </mat-dialog-actions>
        </div>
    </div>
    <div class="dialog-bottom">
        <div class="machine-name">
            {{topLosses?.name}}
        </div>
    </div>
</div>

<ng-container *ngIf="bottleNeckData && bottleNeckData.length > 0; else noData">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" aria-label="Bottle Neck Data">

        <ng-container matColumnDef="autoLoss">
            <th mat-header-cell *matHeaderCellDef scope="col"> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.autoLoss}} </td>
        </ng-container>

        <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef scope="col"> Duration (Mins) </th>
            <td mat-cell *matCellDef="let element"> {{element.value | localDecimalPipe}} </td>
        </ng-container>

        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef scope="col"> Count </th>
            <td mat-cell *matCellDef="let element"> {{element.count}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>
</ng-container>
<ng-template #noData>
    <div class="no-data-wrapper">
        {{'search.no_data_found' | translate}}
    </div>
</ng-template>

<div class="link-wrapper">
    <div class="causal-link" (click)="openCausalPopup()" (keydown.enter)="openCausalPopup()"
        (keydown.space)="openCausalPopup()" >
        {{'machine_view.loss_popup.causal_link' | translate}}
    </div>

    <div class="dfos-link">
        <a target="_blank" href="{{dfosURL}}" rel="noopener">
            {{'machine_view.loss_popup.dfos_link' | translate}}
        </a>
    </div>
</div>